import styled from "styled-components";
import { type SpaceProps, type DisplayProps, space, display } from "styled-system";
import { theme } from "../theme/lexusTheme";

export const Hr = styled.hr<SpaceProps & DisplayProps>`
    display: block;
    width: 100%;
    border: 0;
    border-bottom: 1px solid ${theme.colors.platinumLight};
    ${display};
    ${space};
`;

export default Hr;
